// extracted by mini-css-extract-plugin
var _1 = "InfoStyles__avatar--Z6SCt";
var _2 = "InfoStyles__descList--c8FTA OfficeGeneral__centeredColumn--asLhi";
var _3 = "InfoStyles__hasCursor--cvilO";
var _4 = "InfoStyles__link--IBVkt OfficeGeneral__inlineLink--J2Xk5 OfficeGeneral__inlineLinkBase--ofwQY OfficeGeneral__roboto--WQooW CoreGeneral__roboto--UlmjE";
var _5 = "InfoStyles__mDesc--XFwgB";
var _6 = "InfoStyles__mInfo--AxpFE";
var _7 = "InfoStyles__mInfoLeft--S5_4P InfoStyles__mInfo--AxpFE";
var _8 = "InfoStyles__mName--mIUDb OfficeGeneral__robotoSlab--GdBSw OfficeGeneral__robotoMedium--itFSf CoreGeneral__robotoMedium--xrjYk";
var _9 = "InfoStyles__mOption--euKQG";
var _a = "InfoStyles__nameColon--Dqe2z";
var _b = "InfoStyles__notice--hy7fG";
export { _1 as "avatar", _2 as "descList", _3 as "hasCursor", _4 as "link", _5 as "mDesc", _6 as "mInfo", _7 as "mInfoLeft", _8 as "mName", _9 as "mOption", _a as "nameColon", _b as "notice" }
